import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { useAntdTable } from 'ahooks';
import { VtxDatagrid, VtxPageLayout, VtxSearch, VtxDatePicker, VtxSelect } from '@vtx/components';
import { getCheckPage } from './api';
import VtxGasStaffModal from '../vtx-gas-staff-modal';
import useSettings from '../vm-hooks/useSettings';

const { Option } = VtxSelect;
const { VtxRangePicker } = VtxDatePicker;
const { TableLayout } = VtxPageLayout;

const InspectionInfo = props => {
    const { id, bottleOperateTypeList, urlHead } = props;
    const [form] = Form.useForm();
    const [dataSearch, setDataSearch] = useState({});
    const { refresh, tableProps, search } = useAntdTable(getCheckPage(id, dataSearch, urlHead), {
        defaultPageSize: 10,
        form,
    });
    const { submit } = search;
    // 表格列
    const columns = [
        {
            title: '气瓶条码号',
            dataIndex: 'bottleNo',
        },
        {
            title: '检验人员',
            dataIndex: 'checkUserName',
            render: (text, record) => {
                const { checkUserId, checkUserName } = record;
                return <VtxGasStaffModal id={checkUserId} label={checkUserName} urlHead={urlHead} />;
            },
        },
        {
            title: '检验时间',
            dataIndex: 'operateTime',
        },
        {
            title: '检验情况',
            dataIndex: 'checkResult',
            render: (text, record) => {
                return record?.checkResult.value;
            },
        },
    ];
    const { current, pageSize } = tableProps?.pagination;
    const datagridProps = {
        ...tableProps,
        columns,
        startIndex: (current - 1) * pageSize + 1,
        onRefresh: refresh,
        toolbar: false,
    };
    const { theme } = useSettings();
    return (
        <TableLayout.Page>
            <TableLayout.Search>
                <Form form={form} name="query-form">
                    <VtxSearch
                        titles={['日期', '操作类型']}
                        gridWeight={[2, 1]}
                        isConfirmButton={false}
                        isClearButton={false}
                    >
                        <Form.Item name="data">
                            <VtxRangePicker
                                dropdownClassName={theme}
                                onChange={(data, dataStr) => {
                                    setDataSearch({
                                        ...dataSearch,
                                        startDate: dataStr[0],
                                        endDate: dataStr[1],
                                    });
                                    submit();
                                }}
                            />
                        </Form.Item>
                        <Form.Item name="operateType">
                            <VtxSelect
                                placeholder="请选择"
                                onChange={submit}
                                dropdownClassName={theme}
                            >
                                {bottleOperateTypeList.map(item => (
                                    <Option key={item.id}>{item.name}</Option>
                                ))}
                            </VtxSelect>
                        </Form.Item>
                    </VtxSearch>
                </Form>
            </TableLayout.Search>
            <TableLayout.Content>
                <TableLayout.Table>
                    <VtxDatagrid style={{ paddingTop: '10px' }} {...datagridProps} />
                </TableLayout.Table>
            </TableLayout.Content>
        </TableLayout.Page>
    );
};

InspectionInfo.propTypes = {
    id: PropTypes.string,
    bottleOperateTypeList: PropTypes.array,
    urlHead: PropTypes.string,
};

export default InspectionInfo;
